import {
  FETCHING_COST_OBJS,
  FETCH_COST_OBJS_SUCCESS,
  CREATING_COST_OBJ,
  CREATE_COST_OBJ_SUCCESS,
  FETCHING_LOCATION_TYPES,
  FETCH_LOCATION_TYPES_SUCCESS,
  FETCHING_COST_OBJ_BY_ALLOCATION_UNIT_ID,
  FETCH_COST_OBJ_BY_ALLOCATION_UNIT_ID_SUCCESS,
  FETCHING_ALL_COST_OBJECTS,
  FETCH_ALL_COST_OBJECTS,
  SELECT_COST_OBJECT,
  CLEAR_COST_OBJECTS,
  FETCHING_COST_OBJ,
  FETCH_COST_OBJ_SUCCESS,
  DELETE_COST_OBJ_FAILED,
  RESET_DELETE_FAILED
} from './CostObjsConstants';

const initialStore = {
  costObjs: [],
  costObj: {},
  allCostObjs: [],
  pageState: {
    page: 0,
    perPage: 10,
    totalEntries: 0,
    totalPages: 0
  },
  locationTypes: [],
  fetchingCostObjs: false,
  fetchingCostObj: false,
  creatingCostObj: false,
  fetchingLocationTypes: false,
  errorMessage: ''
};

const CostObjsReducer = (state = initialStore, action) => {
  switch (action.type) {
    case FETCH_COST_OBJS_SUCCESS:
      return {
        ...state,
        costObjs: action.costObjs.map(({ id, name, description }) => ({
          id,
          name,
          description
        })),
        pageState: action.pageState,
        fetchingCostObjs: false
      };
    case FETCH_COST_OBJ_BY_ALLOCATION_UNIT_ID_SUCCESS:
      return {
        ...state,
        costObjs: [...action.costObjs],
        fetchingCostObjs: false
      };
    case FETCHING_COST_OBJS:
      return {
        ...state,
        fetchingCostObjs: true,
        pageState: {
          ...initialStore.pageState,
          page: action.pageStats.page,
          perPage: action.pageStats.perPage
        }
      };
    case FETCHING_COST_OBJ_BY_ALLOCATION_UNIT_ID:
      return { ...state, fetchingCostObjs: true };
    case CREATING_COST_OBJ:
      return { ...state, creatingCostObjs: true };
    case CREATE_COST_OBJ_SUCCESS:
      return { ...state, creatingCostObjs: false };
    case FETCHING_ALL_COST_OBJECTS:
      return { ...state, fetchingCostObjs: true };
    case FETCH_ALL_COST_OBJECTS:
      return {
        ...state,
        fetchingCostObjs: false,
        allCostObjs: [...action.costObjs]
      };
    case FETCHING_LOCATION_TYPES:
      return { ...state, fetchingLocationTypes: true };
    case SELECT_COST_OBJECT: // eslint-disable-line no-case-declarations
      const { oldCostObject, newCostObject } = action;
      const modifiedAllCostObjects = state.allCostObjs.map(costObj => {
        if (costObj.id === newCostObject) return { ...costObj, disabled: true };
        else if (costObj.id === oldCostObject) {
          return { ...costObj, disabled: false };
        } else return { ...costObj };
      });
      const modifiedCostObjects = state.costObjs.map(costObj => {
        if (costObj.id === newCostObject) return { ...costObj, disabled: true };
        else if (costObj.id === oldCostObject) {
          return { ...costObj, disabled: false };
        } else return { ...costObj };
      });
      return {
        ...state,
        allCostObjs: modifiedAllCostObjects,
        costObjs: modifiedCostObjects
      };
    case FETCH_LOCATION_TYPES_SUCCESS: // eslint-disable-line no-case-declarations
      return {
        ...state,
        fetchingLocationTypes: false,
        locationTypes: action.locationTypes
      };
    case CLEAR_COST_OBJECTS:
      return {
        ...state,
        costObjs: [],
        allCostObjs: []
      };
    case FETCHING_COST_OBJ:
      return {
        ...state,
        fetchingCostObj: true
      };
    case FETCH_COST_OBJ_SUCCESS:
      return {
        ...state,
        fetchingCostObj: false,
        costObj: action.costObj
      };
    case DELETE_COST_OBJ_FAILED:
      return {
        ...state,
        errorMessage: action.message
      };
    case RESET_DELETE_FAILED:
      return {
        ...state,
        errorMessage: ''
      };
    default:
      return { ...state };
  }
};

export default CostObjsReducer;



// WEBPACK FOOTER //
// ./src/redux/costObjs/CostObjsReducer.js